<style lang="css" scoped="">
  .title {
    font-size: 1rem;
  }
  .subtitle {
    font-size: 0.8rem;
  }
  p.subtitle.title1 {
      padding: 0px;
      margin-bottom: 0px;
  }
  .Custome_card-content {
    padding-top: 0rem !important;
}
  .field1{ margin:0 3px;}
  .boxwidth {
    width:31% !important;
  }
</style>

<template lang="html">
 <div class="container-fluid">
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <div>
      <div class="card">
        <div class="card-header"> Case Counts </div>
        <div class="card-body">
           <div class="row">
             <div class="col-6 col-lg-2">
                <b-card no-block>
                    <div class="h5 text-warning text-center mb-0 mt-2">
                        <router-link target="_self" title="Pending Cases"  :class="[{ 'click-not-allowed':emailStatus.AllocationPending<=0 }, 'text-warning']"
                            :to="{ path: '/emailtracking',query: { status:'allocationpending',tlemail:filter.tlemailid}}">
                              {{emailStatus.AllocationPending}}
                        </router-link>
                    </div>
                    <div class="h6 text-warning text-center mb-0 mt-2">Pending</div>
                    <div class="text-muted font-weight-bold text-center font-xs"><small>(As Of Now)</small></div>
                </b-card>
              </div><!--/.col-->
               <div class="col-6 col-lg-2">
                <b-card no-block>
                    <div class="h5 text-danger text-center mb-0 mt-2">
                       <router-link target="_self" title="Allocated Cases" :class="[{'click-not-allowed':emailStatus.Allocated<=0}, 'text-danger']"
                         :to="{ path: '/emailtracking', query: { status:'allocated',tlemail:filter.tlemailid}}">
                              {{emailStatus.Allocated}}
                       </router-link>
                    </div>
                    <div class="h6 text-danger text-center mb-0 mt-2">Allocated</div>
                    <div class="text-muted font-weight-bold text-center font-xs"><small>(As Of Now)</small></div>
                </b-card>
              </div><!--/.col-->
              <div class="col-6 col-lg-2">
                <b-card no-block>
                    <div class="h5 text-primary text-center mb-0 mt-2">
                      <router-link target="_self" title="InProcess Cases" :class="[{'click-not-allowed':emailStatus.InProcess<=0}, 'text-primary']"
                        :to="{ path: '/emailtracking', query: { status:'inprocess',tlemail:filter.tlemailid}}">
                        {{emailStatus.InProcess}}
                      </router-link>
                    </div>
                    <div class="h6 text-primary text-center mb-0 mt-2">In Process</div>
                    <div class="text-muted font-weight-bold text-center font-xs"><small>(As Of Now)</small></div>
                </b-card>
              </div><!--/.col-->
              <div class="col-6 col-lg-2">
                <b-card no-block>
                    <div class="h5 text-success text-center mb-0 mt-2">
                      <router-link target="_self" title="Close Cases"  class="has-text-black-bis"  :class="[{'click-not-allowed':emailStatus.Close<=0}, 'text-success']"
                        :to="{ path: '/emailtracking', query: { status:'close',tlemail:filter.tlemailid}}">
                        {{emailStatus.Close}}
                      </router-link>
                    </div>
                    <div class="h6 text-success text-center mb-0 mt-2">Close</div>
                    <div class="text-muted text-center font-weight-bold font-xs"><small>(Today)</small></div>
                </b-card>
              </div><!--/.col-->
              <div class="col-6 col-lg-2">
                <b-card no-block>
                     <div class="h5 text-secondary text-center mb-0 mt-2">
                       <router-link target="_self" title="Spam Cases" class="has-text-black-bis" :class="[{'click-not-allowed':emailStatus.Spam<=0}, 'text-secondary' ]"
                        :to="{ path: '/emailtracking', query: { status:'spam',tlemail:filter.tlemailid}}">
                            {{emailStatus.Spam}}
                        </router-link>
                    </div>
                    <div class="h6 text-secondary text-center mb-0 mt-2">Spam</div>
                    <div class="text-muted text-center font-weight-bold font-xs"><small>(Today)</small></div>
                </b-card>
              </div><!--/.col-->
              <div class="col-6 col-lg-2">
                <b-card no-block>
                     <div class="h5 text-primary text-center mb-0 mt-2">
                       <router-link target="_self" title="Follow Up Cases" class="has-text-black-bis" :class="[{'click-not-allowed':emailStatus.FollowUp<=0}, 'text-primary' ]"
                        :to="{ path: '/emailtracking', query: { status:'followup',tlemail:filter.tlemailid}}">
                            {{emailStatus.FollowUp}}
                        </router-link>
                    </div>
                    <div class="h6 text-primary text-center mb-0 mt-2">Follow Up</div>
                    <div class="text-muted text-center font-weight-bold font-xs"><small>(Today)</small></div>
                </b-card>
              </div><!--/.col-->
              <div class="col-6 col-lg-2">
                <b-card no-block>
                    <div class="h5 text-danger text-center mb-0 mt-2">
                      <router-link target="_self" :class="[{'click-not-allowed':!emailRepeatStatusCount}, 'text-danger']"
                      :to="{ path: '/emailtracking', query: { repeatstatus:'repeatstatus',status:'allocationpending',tlemail:filter.tlemailid}}">
                      {{emailRepeatStatusCount}}
                      </router-link>
                    </div>
                    <div class="h6 text-danger text-center mb-0 mt-2">Repeat Emails</div>
                    <div class="text-muted text-center font-weight-bold font-xs">.</div>
                </b-card>
              </div><!--/.col-->
            </div><!--/.row-->
        </div>
      </div>

      <div class="card">
        <div class="card-header"> Previous Day Status </div>
        <div class="card-body">
          <div class="card-body">
            <div class="row">
              <div class="col-6 col-lg-2">
                <b-card no-block>
                    <div class="h5 text-primary text-center mb-0 mt-2">
                          {{previousDay.TotalEmailsReceived}}
                    </div>
                    <div class="h6 text-primary text-center mb-0 mt-2">Total Email Received</div>
                    <div class="text-muted font-weight-bold text-center font-xs"><small>24 Hrs Format</small></div>
                </b-card>
              </div><!--/.col-->
                <div class="col-6 col-lg-2">
                <b-card no-block>
                    <div class="h5 text-primary text-center mb-0 mt-2">
                          {{previousDay.EmailsReceived}}
                    </div>
                    <div class="h6 text-primary text-center mb-0 mt-2">Email Received</div>
                    <div class="text-muted font-weight-bold text-center font-xs"><small>NonWorking Hour 8 PM-8.59 AM</small></div>
                </b-card>
              </div><!--/.col-->
                <div class="col-6 col-lg-2">
                <b-card no-block>
                    <div class="h5 text-primary text-center mb-0 mt-2">
                          {{previousDay.TotalEmailsClosed}}
                    </div>
                    <div class="h6 text-primary text-center mb-0 mt-2">Total Email Closed</div>
                    <div class="text-muted font-weight-bold text-center font-xs"><small>8.59 AM - 8.30 PM</small></div>
                </b-card>
              </div><!--/.col-->
                <div class="col-6 col-lg-2">
                <b-card no-block>
                    <div class="h5 text-primary text-center mb-0 mt-2">
                          {{previousDay.TotalEmailsSpam}}
                    </div>
                    <div class="h6 text-primary text-center mb-0 mt-2"> Total Email Spam</div>
                    <div class="text-muted font-weight-bold text-center font-xs"><small>8.59 AM - 8.30 PM</small></div>
                </b-card>
              </div><!--/.col-->
              <!--<div class="col-6 col-lg-2">
                <b-card no-block>
                    <div class="h5 text-primary text-center mb-0 mt-2">
                          {{previousDay.TotalEmailsTrash}}
                    </div>
                    <div class="h6 text-primary text-center mb-0 mt-2">Total Email Trash</div>
                    <div class="text-muted font-weight-bold text-center font-xs"><small>8.59 AM - 8.30 PM</small></div>
                </b-card>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
 import apiUrl from '../../../constants'
 import axios from 'axios'
//import CONSTANTS from '@/utils/constants'
//import stores from '@/stores'
//import emailrChart from '@/components/Emailr/charts'
//import EmailrCommonFunctions from '@/components/Emailr/EmailrCommonFunctions'
import commonFunction from '../../../commonFunction'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
export default {
  name: 'tldashboard',
  components: {
   // emailrChart
   Loading
  },
  data () {
    return {
      emailStatus: {
        AllocationPending: 0,
        Allocated: 0,
        InProcess: 0,
        Close: 0,
        Spam: 0,
        Trash: 0,
        FollowUp: 0
      },
      previousDay: {
        TotalEmailsReceived: 0,
        EmailsReceived: 0,
        TotalEmailsClosed: 0,
        TotalEmailsSpam: 0,
        TotalEmailsTrash: 0
      },
      pendingEmailAgingData: [],
      barLabels: [],
      barData: [],
      agents: [],
      designation: '',
      filter: {
        subdepartmentid: '',
        tlemailid: '',
        amemailid: '',
        manageremailid: '',
        location: {
          location:'',
          locationid:''
        }
      },
      isLocationDisabled: false,
      locations: [],
      isFullPage: true,
      isLoading: false,
      userDetails: {},
      subDepartmentList: [],
      ivr: {
        oncall: 0,
        shortbrk: 0,
        longbrk: 0,
        logout: 0,
        rnf: 0,
        inqueue: 0,
        onemail: 0
      },
      tlemailid: '',
      disableTl: false,
      tlMaster: [],
      disableAgent: false,
      agentemailid: '',
      isReloading: true,
      allocationPendingCounts: [],
      allocatedCounts: [],
      inprocessCount: [],
      emailRepeatStatusCount: 0,
      emailRepeatStatus: {
        AllocationPending: 0,
        Allocated: 0,
        InProcess: 0,
        Close: 0
      },
      repeatStatusTitle: '',
      fullPage: false
    }
  },
  mounted () {

    /*let perm = stores.user.hasPermission('/emailr/tldashboard', 'Read')
    if (!perm) {
      this.$router.push({
        path: '/'
      })
      return this.$buefy.toast.open({
        message: 'You do not have access to this page.',
        type: 'is-danger'
      })
    } else {
      this.userDetails = stores.user.getLoggedinUserData()
      this.designation = this.userDetails.role
      this.loggedUserEmail = this.userDetails.emailaddress
      this.filter.subdepartmentid = this.userDetails.subdepartment[0].subdepartmentid
      this.subDepartmentList = this.userDetails.subdepartment.filter((m) => {
        if ((m.subdeptname) && (m.subdeptname.toLowerCase() === 'ccemail' || m.subdeptname.toLowerCase() === 'babyhugemail')) {
          this.filter.subdepartmentid = m.subdepartmentid
          return m
        }
      })
      this.loggedUser = stores.user.getLoggedinUserData()
      this.checkConditions()
    }*/

    [this.subDepartmentList, this.DepartmentID,this.userdetail,this.permissiondata,this.userTypeForTicket, this.SummarySelectOptionObj, this.SummaryOptionObj]=commonFunction.getuserDetailsAndpermissionData();
      // console.log( 'subDepartmentList ::::::::::::::::::::::::::::::::::::::::::: '+JSON.stringify(this.subDepartmentList ));
    this.filter.subdepartmentid =  this.DepartmentID;
    this.subDepartmentList = this.subDepartmentList.filter(function (dept) {
          return dept.text == "Outbound Call Center" || dept.text == "Inbound Call Center";
    })

    this.userid = this.userdetail[0].userid;
    this.username = this.userdetail[0].username;
    this.userRole = this.userdetail[0].roles[0].rolename;
    this.checkConditions()

  },
  methods: {

    checkConditions: function () {
      if (this.userRole.toLowerCase() === 'associate') {
        this.filter.agent = this.userDetails.emailaddress
        this.emailsStatusWiseCount()
      } else if (this.userRole.toLowerCase() === 'team leader') {

        this.disableTl = true
        this.filter.tlemailid = this.userDetails.emailaddress
        this.isLocationDisabled = false

        this.previousDayStatus()
        this.emailsStatusWiseCount()

      } else if (this.userRole.toLowerCase() === 'assistantmanager') {
        this.filter.amemailid = this.userDetails.emailaddress

      } else if (this.userRole.toLowerCase() === 'manager') {
        this.filter.manageremailid = this.userDetails.emailaddress

      } else {

        this.previousDayStatus()
        this.emailsStatusWiseCount()
        this.emailsRepeatStatusWiseCount()
        this.getpendingagingcase()
      }
    },
    checkTlDisabled: function () {
      if (!this.filter.tlemailid) {
        this.filter.location = ''
      }
      this.getAllCounts()
    },
    getTlList: function () {
      this.filter.tlemailid = ''
      if (this.userDetails.role.toLowerCase() === 'teamlead') {
        this.getAllTeamLead()
      } else {
        this.tlMaster = []
        let getRoleObj = {
          rolename: 'teamlead',
          emailaddress: this.loggedUser.emailaddress,
          subdepartmentid: this.filter.subdepartmentid,
          systemid: this.loggedUser.systemId,
          locationid: this.filter.location.locationid || ''
        }
        return http.get(`${CONSTANTS.API_URL}/api/get/supervisor/feedbackrole`, getRoleObj)
          .then((result) => {
            if (result && result.data.length) {
              result.data.forEach((agent) => {
                this.tlMaster.push(agent.emailaddress)
              })
              this.filter.tlemailid = result.data[0].emailaddress
              this.getAllCounts()
            }
          })
          .catch((HTTPException) => {
            return this.$buefy.toast.open({
              message: HTTPException.message,
              type: 'is-danger'
            })
          })
      }
    },
    getAllCounts: function () {
      this.isLoading = true
      this.emailsStatusWiseCount()
      this.emailsRepeatStatusWiseCount()
      this.getpendingagingcase()
      this.getAgents() // Get list of agents reporting to loggedUser
      this.previousDayStatus()
    },
    // Get Agent list reporting to loggedUser
    getAgents: async function () {
      this.agents = []
      this.ivr.inqueue = 0
      this.ivr.oncall = 0
      this.ivr.shortbrk = 0
      this.ivr.longbrk = 0
      this.ivr.logout = 0
      this.ivr.rnf = 0
      this.ivr.onemail = 0
      if (this.filter.tlemailid) {
        try {
          let getAgentObj = {
            systemid: this.loggedUser.systemId,
            emailaddress: this.filter.tlemailid,
            subdepartmentid: this.filter.subdepartmentid
          }
          this.isLoading = true
          const result = await http.post(`${CONSTANTS.API_URL}/api/usermgt/fetch/agentundertl`, getAgentObj)

          if (result) {
            this.isLoading = false
            let agentsEmails = ''
            if (result && result.data && result.data.length) {
              result.data.forEach((agent) => {
                agentsEmails += agent.userroledetail.usermaster.emailaddress + ','

                this.agents.push(agent.userroledetail.usermaster.emailaddress)
              })
            }
            this.getCountFromIVR(agentsEmails)
          }
        } catch (httpException) {
          this.isLoading = false
          return this.$buefy.toast.open({
            message: httpException.message,
            type: 'is-danger'
          })
        }
      }
    },
    getCountFromIVR: function (agnets) {
      if (agnets && agnets.length) {
        let getAgentObj = {
          emails: agnets,
          location: this.filter.location.location
        }
        this.isLoading = true
        return http.post(`${CONSTANTS.API_URL}/api/ivr/getagentwisedashboard`, getAgentObj)
          .then((result) => {
            this.isLoading = false
            if (result.flag === 1) {
              this.ivr = {
                inqueue: this.agents.length,
                oncall: result.oncall || 0,
                shortbrk: result.shortbrk || 0,
                longbrk: result.longbrk || 0,
                logout: result.logout || 0,
                rnf: result.rnf || 0
              }
              this.ivr.onemail = Number(this.ivr.inqueue) - (Number(this.ivr.shortbrk) + Number(this.ivr.longbrk) + Number(this.ivr.logout) + Number(this.ivr.rnf))
            }
          })
          .catch((httpException) => {
            this.isLoading = false
            return this.$buefy.toast.open({
              message: httpException.message,
              type: 'is-danger'
            })
          })
      }
    },
    getpendingagingcase: function (agents) {
      let getpendingagingcaseObj = {
        subdepartmentid: this.filter.subdepartmentid,
        tlemailid: this.filter.tlemailid || ''
      }
      Object.keys(getpendingagingcaseObj).forEach((key) => {
        if (getpendingagingcaseObj[key] === '' || getpendingagingcaseObj[key] === null || getpendingagingcaseObj[key] === undefined) {
          delete getpendingagingcaseObj[key]
        }
      })
      this.isLoading = true
      return axios({
          'method': 'POST',
          'url': apiUrl.api_url + 'getpendingagingcase',
          headers: commonFunction.getusertoken(),
          'data': getpendingagingcaseObj
     }).then((result) => {
          this.isLoading = false
          this.barLabels = []
          this.barData = []
          this.allocationPendingCounts = []
          this.allocatedCounts = []
          this.inprocessCount = []
          if (result.data) {
            this.pendingEmailAgingData = result.data
            for (let data of result.data) {
              this.barLabels.push(data.labelname + ' Hrs')
              if (data.labelvalue && data.labelvalue.AllocationPending >= 0) {
                this.allocationPendingCounts.push(data.labelvalue.AllocationPending)
              }
              if (data.labelvalue && data.labelvalue.Allocated >= 0) {
                this.allocatedCounts.push(data.labelvalue.Allocated)
              }
              if (data.labelvalue && data.labelvalue.InProcess >= 0) {
                this.inprocessCount.push(data.labelvalue.InProcess)
              }
            }
            this.barData = [{
              label: 'Pending',
              data: this.allocationPendingCounts,
              barThickness: 17,
              backgroundColor: '#fea223',
              borderWidth: 2
            },
            {
              label: 'Allocated',
              data: this.allocatedCounts,
              barThickness: 17,
              backgroundColor: '#e6345d',
              borderWidth: 2
            },
            {
              label: 'InProcess',
              data: this.inprocessCount,
              barThickness: 17,
              backgroundColor: '#32a3cb',
              borderWidth: 2
            }]
          }
        }).then((result) => {
          this.isLoading = false
        }).catch((httpException) => {
          this.isLoading = false
          this.$alertify.error( httpException.message )
        })
    },
    // Get status (Total Email Received ,Email Received Non Working Hour (8.00 pm-8.59 am)
    // Total Email Closed (8.59 am - 8.30 pm),Total Email Spam (8.59 am - 8.30 pm) Total Email Trash
    // (8.59 am - 8.30 pm) count of case Last days i.e previous day
    previousDayStatus: function (agents) {
      let previousDayStatusObj = {
        subdepartmentid: this.filter.subdepartmentid,
        tlemailid: this.filter.tlemailid || '',
        amemailid: this.filter.amemailid || '',
        manageremailid: this.filter.manageremailid || ''
      }
      Object.keys(previousDayStatusObj).forEach((key) => {
        if (previousDayStatusObj[key] === '' || previousDayStatusObj[key] === null || previousDayStatusObj[key] === undefined) {
          delete previousDayStatusObj[key]
        }
      })
      this.isLoading = true
      return axios({
          'method': 'POST',
          'url': apiUrl.api_url + 'getpriviousdaycase',
          headers: commonFunction.getusertoken(),
          'data': previousDayStatusObj
      }).then((result) => {
          this.isLoading = false
          if (result.data) {
            this.previousDay.TotalEmailsReceived = result.data.TotalEmailsReceived ? result.data.TotalEmailsReceived : 0
            this.previousDay.EmailsReceived = result.data.EmailsReceived ? result.data.EmailsReceived : 0
            this.previousDay.TotalEmailsClosed = result.data.TotalEmailsClosed.length ? result.data.TotalEmailsClosed[0].count : 0
            this.previousDay.TotalEmailsSpam = result.data.TotalEmailsSpam.length ? result.data.TotalEmailsSpam[0].count : 0
            this.previousDay.TotalEmailsTrash = result.data.TotalEmailsTrash.length ? result.data.TotalEmailsTrash[0].count : 0
          }
        }).catch((httpException) => {
          this.isLoading = false
          return this.$alertify.error( httpException.message )
        })
    },
    // Get count of cases (AllocationPending,Allocated,InProcess,Close,Spam,Trash)
    emailsStatusWiseCount: function (agents) {
// console.log("TL-----------------------------------------------------------------------FRONTEND",this.filter.subdepartmentid);

      if (this.filter.subdepartmentid) {
        let getCountObj = {
          subdepartmentid: this.filter.subdepartmentid,
          // subdepartmentid: "19",
          tlemailid: this.filter.tlemailid || '',
          amemailid: this.filter.amemailid || '',
          manageremailid: this.filter.manageremailid || ''
        }
        // console.log("getCountObj (fetchcasestatuscount) ------------------------------------------------------00",getCountObj);
        Object.keys(getCountObj).forEach((key) => {
          if (getCountObj[key] === '' || getCountObj[key] === null || getCountObj[key] === undefined) {
            delete getCountObj[key]
          }
        })
        this.isLoading = true
        axios({
          'method': 'POST',
          'url': apiUrl.api_url + 'fetchcasestatuscount',
          headers: commonFunction.getusertoken(),
          'data': getCountObj
        }).then((result) => {
            this.isLoading = false
            if (result.data) {
              // console.log("AAAA result.data : fetchcasestatuscount --------------------------------------------",result.data);
              this.emailStatus.AllocationPending = result.data.allocationpending || 0
              this.emailStatus.Allocated = result.data.allocated || 0
              this.emailStatus.InProcess = result.data.inprocess || 0
              this.emailStatus.Close = result.data.close || 0
              this.emailStatus.Spam = result.data.spam || 0
              this.emailStatus.Trash = result.data.trash || 0
              this.emailStatus.FollowUp = result.data.followup || 0
            }
          }).catch((httpException) => {
            this.isLoading = false
            this.$alertify.error( httpException.message );
          })
      }
    },
    // Get count of cases (AllocationPending,Allocated,InProcess,Close,Spam,Trash)
    emailsRepeatStatusWiseCount: function (agents) {
      // console.log("TL ------------------------------------------------------- ");
      if (this.filter.subdepartmentid) {
        let getCountObj = {
          subdepartmentid: this.filter.subdepartmentid,
          tlemailid: this.filter.tlemailid || '',
          amemailid: this.filter.amemailid || '',
          manageremailid: this.filter.manageremailid || ''
        }
        Object.keys(getCountObj).forEach((key) => {
          if (getCountObj[key] === '' || getCountObj[key] === null || getCountObj[key] === undefined) {
            delete getCountObj[key]
          }
        })
        this.isLoading = true
        return axios({
          'method': 'POST',
          'url': apiUrl.api_url + 'fetchrepeatcasestatuscount',
          headers: commonFunction.getusertoken(),
          'data': getCountObj
        }).then((result) => {
            this.isLoading = false
            if (result) {
              this.emailRepeatStatus.AllocationPending = result.data.allocationpending || 0
              this.emailRepeatStatus.Allocated = result.data.allocated || 0
              this.emailRepeatStatus.InProcess = result.data.inprocess || 0
              this.emailRepeatStatusCount = result.data.allocationpending + result.data.allocated + result.data.inprocess
              this.repeatStatusTitle = `Pending: ${this.emailRepeatStatus.AllocationPending}, Allocated: ${this.emailRepeatStatus.Allocated}, InProcess: ${this.emailRepeatStatus.InProcess}`
            }
          }).catch((httpException) => {
            this.isLoading = false
            this.$alertify.error( httpException.message )
          })
      }
    },
    getAllActiveLocations:async function () {
      this.locations = []
      this.filter.location = ''
        try {
          let res = await http.get(`${CONSTANTS.API_URL}/api/locations`)
          if (res.data.rows && res.data.rows.length) {
            res.data.rows.forEach((each)=>{
              if (this.userDetails.role === 'teamlead') {
                if (this.userDetails.location === each.location) {
                  this.filter.location = {
                    location:each.location,
                    locationid:each.locationid
                  }
                }
              }
              this.locations.push({
                location:each.location,
                locationid:each.locationid
              })
            })
          }
        } catch (e) {
          console.log('Error in get locations',e);
        }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/components/emailr/tlDashboard.vue?3e072387